export class LotteryInstallmentConfigurationModel {
  constructor(
    public key: number,
    public lotteryInstKey: number,
    public installmentType: string,
    public installmentPercent: number,
    public instPaymentInterestRate: number,
    public installmentDuePaymentDays: number,
    public installmentDuePaymentDaysWithInterest: number,
    public otherCharge: string,
    public installmentAmount: number,
    public lotteryKey: number,
    public intrestChartLst: string[] //  public intrestChartLst: { //   key: number;
  ) //   startDate: string;
  //   endDate: string;
  //   instPaymentInterestRate: number;
  // }[]
  {}
}
